import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from './Skeleton';
import styles from './Skeleton.module.scss';

/* ────────────────────────────────────────────────────────────
 * SkeletonCard — card-tile-shaped skeleton.
 *
 * Visual stand-in for a StatCard / tile-grid card during first
 * paint. Use inside the same grid container the real cards
 * will land in, so the layout doesn't reflow when data arrives.
 *
 *   <div className="grid">
 *     {loading
 *       ? Array.from({length: 4}, (_, i) => <SkeletonCard key={i} />)
 *       : data.map((d) => <StatCard ... />)}
 *   </div>
 * ──────────────────────────────────────────────────────────── */

const SkeletonCard = ({ lines, className }) => {
  return (
    <div className={[styles.card, className || ''].filter(Boolean).join(' ')}>
      <Skeleton width="40%" height="0.75rem" />
      <Skeleton width="65%" height="1.75rem" className={styles.cardHero} />
      {Array.from({ length: Math.max(0, lines) }, (_, i) => (
        <Skeleton
          key={i}
          width={i % 2 === 0 ? '85%' : '60%'}
          height="0.75rem"
          className={styles.cardLine}
        />
      ))}
    </div>
  );
};

SkeletonCard.propTypes = {
  lines: PropTypes.number,
  className: PropTypes.string,
};

SkeletonCard.defaultProps = {
  lines: 2,
  className: '',
};

export default SkeletonCard;
